import { ReactNode } from 'react';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface ISidebarSector {
  label?: string;
  collapsed: boolean;
  children: ReactNode;
}

export const Sector = ({ label, collapsed, children }: ISidebarSector) => (
  <div className={cx(s.sector, label && collapsed && s.sectorCollapsed)}>
    {label && !collapsed && (
      <Text size={Text.size.xxs} color={Text.color.tertiaryBlue} className={s.sectorLabel}>
        {label}
      </Text>
    )}
    {children}
  </div>
);
